import React from "react";
import { FiAlertTriangle } from "react-icons/fi";
import { Button } from "@chakra-ui/react";

import { useExecutiveView } from "../../hooks/useExecutiveView";
import { useSwitchCompany } from "../../hooks/useSwitchCompany";

export const ExecutiveViewBanner: React.FC = () => {
	const { isActive, companyName } = useExecutiveView();
	const { switchBack, isLoading } = useSwitchCompany();

	if (!isActive) {
		return null;
	}

	const handleExit = () => {
		switchBack();
	};

	return (
		<div
			role="status"
			aria-live="polite"
			className="sticky top-0 z-50 flex min-h-12 w-full items-center justify-between bg-red-700 px-4 font-semibold text-white"
		>
			<div className="flex items-center gap-2">
				<FiAlertTriangle aria-hidden="true" />
				<span>
					YOU ARE LOGGED IN AS AN EXECUTIVE USER AND VIEWING{" "}
					{companyName?.toUpperCase()} COMPANY
				</span>
			</div>
			<Button
				variant="ghost"
				className="text-white underline"
				onClick={handleExit}
				isLoading={isLoading}
				_hover={{ bg: "whiteAlpha.200" }}
			>
				Exit
			</Button>
		</div>
	);
};
